import moment from 'moment'
import gql from 'graphql-tag'
import client from '@stores/apollo'
import { Role, IEmployeeDetails, ITag } from '@api'
import { EmployeeDetailsFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

export interface IUpdateEmployeeInput {
  id: string
  name?: string
  title?: string
  role?: Role
  managerId?: string | null
  email?: string
  phone?: string | null
  departmentId?: string | null
  employmentType?: string
  geoLocationId?: string | null
  startDate?: string | null
  endDate?: string | null
  badge?: string | null
  note?: string
  assignmentPlanId?: string
  exemptFromCheckIn?: boolean
  isRemote?: boolean
  noDeskNeeded?: boolean
  bookingManagerSetting?: any
  tagNames?: ITag[]
  workplaceGroupIds?: string[]
  bookingsManagerSetting?: any
}

interface IPayload {
  updateEmployee: {
    employee: IEmployeeDetails
  }
}

const mutateHandler = handleFetchResult<IPayload, IEmployeeDetails>({
  handler: (data: IPayload) => {
    const { employee } = data.updateEmployee
    return {
      ...employee,
      startDate: employee.startDate ? moment(employee.startDate).toDate() : null,
      endDate: employee.endDate ? moment(employee.endDate).toDate() : null,
    }
  },
  name: 'Employee update',
})

export default function update(input: IUpdateEmployeeInput): Promise<IEmployeeDetails> {
  return client.gql
    .mutate({
      mutation,
      variables: { input, assignmentPlanId: null },
    })
    .then(mutateHandler)
}

const mutation = gql`
  mutation UpdateEmployee($input: UpdateEmployeeInput!, $assignmentPlanId: ID) {
    updateEmployee(input: $input) {
      employee {
        ...EmployeeDetailsFragment
      }
    }
  }
  ${EmployeeDetailsFragment}
`
